(function () {
  function createOverlay() {
    const overlay = document.createElement("div");
    overlay.id = "czOverlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");

    const img = document.createElement("img");
    img.id = "czImage";
    img.alt = "Zoom";

    const closeBtn = document.createElement("button");
    closeBtn.id = "czClose";
    closeBtn.type = "button";
    closeBtn.textContent = "Cerrar";

    overlay.appendChild(closeBtn);
    overlay.appendChild(img);
    document.body.appendChild(overlay);

    function close() {
      overlay.style.display = "none";
      img.src = "";
      document.body.style.overflow = "";
    }

    closeBtn.addEventListener("click", close);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });

    return {
      open: function (src) {
        img.src = src;
        overlay.style.display = "flex";
        document.body.style.overflow = "hidden";
      },
    };
  }

  let ui;

  function onClick(e) {
    const btn = e.target.closest(".btn-zoom");
    if (!btn) return;

    const url = (btn.getAttribute("data-zoom") || "").trim();
    if (!url) return;

    if (!ui) ui = createOverlay();
    ui.open(url);
  }

  document.addEventListener("click", onClick, true);
})();
